import LinearProgress from "@material-ui/core/LinearProgress";
import withStyles from "@material-ui/core/styles/withStyles";
import { css, cx } from "emotion";
import React from "react";
import ImgLogin from "../../../assets/images/img_login.jpg";
import logoSHOPFROMIZY from "../../../assets/images/logo-SHOPFROMIZY.png";
import { useForm } from "react-hook-form";
import AuthStore from "../../../Store/AuthStore";
import Snackbars from "../../../components/Snackbars/Snackbars";

const LinearProgressCustom = withStyles((theme) => ({
  root: {
    height: 10,
  },
  colorPrimary: {
    backgroundColor: "#2196F3",
  },
  barColorPrimary: {
    backgroundColor: "#67b6f5",
  },
}))(LinearProgress);

const ForgotPassword = (props) => {
  const [authState, authActions] = AuthStore();
  const { register, handleSubmit, formState: {errors, isValid}, watch } = useForm({
    mode: "all",
    reValidateMode: "onChange",
  });
  const { isLoading, status, message } = authState;

  const onSubmit = (data) => {
    authActions.onForgotPassword(data?.email);
  };

  const onShowSnackbar = () => {
    let title = "";
    if (status === 403) {
      title = "You are off duty. Please contact your supervisor";
    } else if (status === 404) {
      title = "Email not registred";
    } else {
      title = message;
    }

    if (title) {
      return <Snackbars msg={title} />;
    } else {
      return null;
    }
  };

  return (
    <div className="d-flex justify-content-start align-items-start">
      {status && status !== 200 && onShowSnackbar()}
      <div
        className={cx(
          css`
            background: url(${ImgLogin});
            background-size: auto 100%;
            height: 100vh;
            width: calc(100vh * 0.59);
          `,
          "d-none d-xl-block"
        )}
      ></div>
      <div
        className={cx(
          css`
            height: auto;
          `,
          "flex-fill"
        )}
      >
        <div className="row mx-0">
          <div
            className={cx(
              css`
                height: 100vh;
                max-width: 416px !important;
              `,
              "col-lg-6 col-md-12 mx-auto"
            )}
          >
            {isLoading && <LinearProgressCustom />}
            {!isLoading && (
              <hr
                style={{
                  height: 10,
                  width: "100%",
                  backgroundColor: "#2196F3",
                  margin: 0,
                }}
              />
            )}
            <div
              className={cx(
                css`
                  margin-top: 70px;
                `,
                "w-100"
              )}
            >
              <img
                src={logoSHOPFROMIZY}
                style={{ width: 90, marginBottom: 50 }}
                alt="shopfromizy"
              />
              <h2 className="font-bold font-20 mb-4">Forgot Password</h2>
              <form
                className="mt-3"
                onSubmit={handleSubmit(onSubmit)}
                noValidate
              >
                <div className="form-group">
                  <label className="d-block font-bold font-12">Email</label>
                  <input
                    type="text"
                    className={
                      errors?.email
                        ? "form-control rounded-8px border-1-error font-12 bg-gray-300"
                        : "form-control rounded-8px border-0 font-12 bg-gray-300"
                    }
                    name="email"
                    {...register("email",{
                      required: "Masukkan email",
                      pattern: {
                        value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
                        message: "Email format not valid",
                      },
                    })}
                  />
                  {errors.email && (
                    <p className="text-danger font-10 mt-2 pl-3 border-left-4-error">
                      {errors.email?.message}
                    </p>
                  )}
                </div>
                <div className="mt-3 d-flex justify-content-between align-items-center">
                  {isLoading && (
                    <button
                      type="submit"
                      className={cx(
                        css`
                          padding: 9px 60px !important;
                        `,
                        "btn bg-blue text-white rounded-8px border-0 font-12"
                      )}
                      disabled={true}
                    >
                      RESET PASSWORD
                    </button>
                  )}
                  {!isLoading && (
                    <button
                      type="submit"
                      className={cx(
                        css`
                          padding: 9px 60px !important;
                        `,
                        isValid
                          ? "btn bg-blue text-white rounded-8px border-0 font-12"
                          : "btn bg-gray-757575 text-white rounded-8px border-0 font-12"
                      )}
                      disabled={!isValid}
                    >
                      RESET PASSWORD
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
